import LoadingBackdrop from '@/components/Loading/LoadingBackdrop'
import useVerifyToken from '@/hooks/useVerifyToken'
import useAuthStore from '@/stores/useAuthStore'
import { paths } from '@/utils/path'
import { Navigate, useLocation } from 'react-router-dom'

const ProtectedLayout = ({ children }: { children: React.ReactNode }) => {
    const { isLoading } = useVerifyToken()
    const user = useAuthStore((state) => state.employee)
    const location = useLocation()

    // Show loading while verifying token
    if (isLoading) {
        return <LoadingBackdrop />
    }

    // Redirect to login if not authenticated
    if (!user) {
        return (
            <Navigate
                to={
                    paths.login +
                    `?redirect=${encodeURIComponent(location.pathname)}`
                }
            />
        )
    }

    return children
}

export default ProtectedLayout
